import ServiceManager from '../../service/ServiceManager';
import { data } from '../../constants/Constants';
import { getDevice } from './utilApi';


export function listarOpcionesBaja(CorreoElectronico) {
    const DispositivoId = getDevice();
    let params = {};
    params.url = "dealer/ListarOpcionesBaja";
    params.data = {
        'dto.CorreoElectronicoDealer': CorreoElectronico,
        'dto.DispositivoDealer': DispositivoId
    };
    console.log("params.data==>", params.data);
    return ServiceManager.prototype.Post(params);
}

export function registrarBaja(CorreoElectronico, CodigoDealer, Baja) {
    const DispositivoId = getDevice();
    let params = {};
    params.url = "dealer/RegistrarBaja";
    params.data = {
        'dto.CorreoElectronicoDealer': CorreoElectronico,
        'dto.CodigoDealer': CodigoDealer,
        'dto.DispositivoDealer': DispositivoId,
        'dto.Sistema': data.Sistema,
        'dto.Baja': Baja
    };
    return ServiceManager.prototype.Post(params);
}

